module.exports = __webpack_public_path__ + "img/0Q3A5061_FoamcoreMatted.8f8b2ecf.jpg";